import { defineMessages } from 'react-intl-next';

export const messages: {
	segmentationTargetGroupsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	segmentationTargetGroupsLabelV2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	segmentationTargetGroupsLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-groups-text-label',
		defaultMessage: 'Target groups',
		description:
			'A visible text label for the segmentation target groups field of the link cards config panel',
	},
	segmentationTargetGroupsLabelV2: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-groups-text-label.v2',
		defaultMessage: 'Target audience groups',
		description:
			'A visible text label for the segmentation target groups field of the link cards config panel',
	},
});
